<template>
  <component :is="motionComponent" v-bind="boundProps">
    <slot />
  </component>
</template>

<script>
import { computed } from 'vue'
import { motion } from 'motion-v'
import { useClinchMotion } from '@/composables/useClinchMotion'

function resolveMotionTag(as) {
  const tag = as || 'div'
  if (motion[tag]) return motion[tag]
  return motion.div
}

export default {
  name: 'ClMotion',
  inheritAttrs: false,
  props: {
    as: { type: String, default: 'motion' },
    preset: { type: String, default: '' },
    initial: { type: [Object, Boolean], default: undefined },
    animate: { type: [Object, Boolean], default: undefined },
    exit: { type: [Object, Boolean], default: undefined },
    transition: { type: Object, default: undefined },
    whileHover: { type: Object, default: undefined },
    whileTap: { type: Object, default: undefined },
    whileInView: { type: [Object, Boolean], default: undefined },
    viewport: { type: Object, default: undefined },
    layout: { type: [Boolean, String], default: undefined }
  },
  setup(props, { attrs }) {
    const { mergeMotionProps } = useClinchMotion()

    const motionComponent = computed(() => resolveMotionTag(props.as === 'motion' ? 'div' : props.as))

    const boundProps = computed(() => {
      const overrides = {
        initial: props.initial,
        animate: props.animate,
        exit: props.exit,
        transition: props.transition,
        whileHover: props.whileHover,
        whileTap: props.whileTap,
        whileInView: props.whileInView,
        viewport: props.viewport,
        layout: props.layout
      }
      const merged = props.preset ? mergeMotionProps(props.preset, overrides) : overrides
      const out = { ...attrs, ...merged }
      if (props.initial === false) {
        out.initial = false
      }
      return out
    })

    return { motionComponent, boundProps }
  }
}
</script>
